import * as Yup from 'yup';
import * as message from '../../../constant/message';

export const locationSchema = Yup.object().shape({
  name: Yup.string().required(message.LOCATION_REQUIRED),
  // cityId: Yup.string().required(message.CITY_REQUIRED),
  // zoneId: Yup.string().required(message.ZONE_REQUIRED),
});
